import { EntityId, createEntityAdapter } from '@reduxjs/toolkit';
import { DialogViewModel } from '@common/model/dialog/dialogViewModel';
import { generateDialogMemberId } from '../../lib';

export type DialogViewModelNormalized = Omit<DialogViewModel, 'members'> & { members: EntityId[]; messages: EntityId[] };

export const dialogsAdapter = createEntityAdapter<DialogViewModelNormalized>();

export const normalizeDialog = (dialog: DialogViewModel): DialogViewModelNormalized => {
  return { messages: [], ...dialog, members: dialog.members.map(generateDialogMemberId) };
};
